<patternlib-footer
  class="text-left"
  [links]="links"
  [additionalLinks]="additionalLinks"
  [showArrowIcon]="showArrowIcon && !footerFixed"
  [showLogo]="!footerFixed"
  (lhClickArrowTop)="onClickArrowTop()"
  (lhClickBrandLogo)="onClickBrandLogo()"
></patternlib-footer>
